import React, { useState } from 'react'
import DevLayout from '../../components/developer/DevLayout'
import { useAuth } from '../../context/AuthContext'
import api from '../../utils/api'

export default function DevChangePassword() {
    const { token } = useAuth()
    const [form, setForm] = useState({ oldPassword: '', newPassword: '', confirmPassword: '' })
    const [loading, setLoading] = useState(false)
    const [msg, setMsg] = useState<{ type: 'success' | 'error', text: string } | null>(null)

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm(prev => ({ ...prev, [e.target.name]: e.target.value }))
    }

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault()
        setMsg(null)
        if (!token) { setMsg({ type: 'error', text: 'Please login first.' }); return }
        if (form.newPassword !== form.confirmPassword) {
            setMsg({ type: 'error', text: 'New passwords do not match.' }); return
        }
        if (form.newPassword.length < 6) {
            setMsg({ type: 'error', text: 'Password must be at least 6 characters.' }); return
        }
        setLoading(true)
        try {
            const res = await api.changePassword(token, { oldPassword: form.oldPassword, newPassword: form.newPassword })
            if (res.message === 'Password changed successfully') {
                setMsg({ type: 'success', text: 'Password changed successfully!' })
                setForm({ oldPassword: '', newPassword: '', confirmPassword: '' })
            } else {
                setMsg({ type: 'error', text: res.message || 'Failed to change password.' })
            }
        } catch (err) {
            setMsg({ type: 'error', text: 'Server error. Please try again.' })
        } finally {
            setLoading(false)
        }
    }

    return (
        <DevLayout>
            <div className="d-flex align-items-center justify-content-between mb-4">
                <div>
                    <h3 className="fw-bold mb-1">Security Settings</h3>
                    <p className="text-muted mb-0">Update your account password to keep your account secure.</p>
                </div>
            </div>

            <div className="row g-4">
                <div className="col-lg-8">
                    <div className="card border-0 shadow-sm rounded-4">
                        <div className="card-header bg-white py-3 border-bottom">
                            <h5 className="mb-0 fw-bold">Change Password</h5>
                        </div>
                        <div className="card-body p-4">
                            {msg && (
                                <div className={`alert alert-${msg.type === 'success' ? 'success' : 'danger'} border-0 shadow-sm mb-4`}>
                                    <i className={`fa-solid ${msg.type === 'success' ? 'fa-circle-check' : 'fa-circle-exclamation'} me-2`}></i>
                                    {msg.text}
                                </div>
                            )}

                            <form onSubmit={handleSubmit}>
                                <div className="row g-3">
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Current Password</label>
                                        <input type="password" name="oldPassword" value={form.oldPassword} onChange={handleChange}
                                            className="form-control bg-light border-0 py-2" placeholder="Enter current password" required />
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold small text-muted text-uppercase">New Password</label>
                                        <input type="password" name="newPassword" value={form.newPassword} onChange={handleChange}
                                            className="form-control bg-light border-0 py-2" placeholder="Enter new password" required />
                                        <div className="form-text small">At least 6 characters long</div>
                                    </div>
                                    <div className="col-md-12">
                                        <label className="form-label fw-bold small text-muted text-uppercase">Confirm New Password</label>
                                        <input type="password" name="confirmPassword" value={form.confirmPassword} onChange={handleChange}
                                            className="form-control bg-light border-0 py-2" placeholder="Confirm new password" required />
                                    </div>
                                    <div className="col-md-12 mt-4">
                                        <button className="btn py-2 px-4 fw-bold rounded-pill shadow-sm border-0" type="submit" disabled={loading}
                                            style={{ backgroundColor: '#8b5e3c', color: '#fff' }}>
                                            {loading ? <><span className="spinner-border spinner-border-sm me-2"></span>Updating...</> : 'Update Password'}
                                        </button>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>

                <div className="col-lg-4">
                    <div className="card border-0 shadow-sm rounded-4" style={{ backgroundColor: 'rgba(201,148,74,0.08)' }}>
                        <div className="card-body p-4">
                            <h5 className="fw-bold mb-3" style={{ color: '#8b5e3c' }}><i className="fa-solid fa-shield-halved me-2"></i>Security Tips</h5>
                            <ul className="list-unstyled small mb-0 d-flex flex-column gap-2 text-dark">
                                <li><i className="fa-solid fa-check me-2" style={{ color: '#8b5e3c' }}></i> Use a password you haven't used before.</li>
                                <li><i className="fa-solid fa-check me-2" style={{ color: '#8b5e3c' }}></i> Mix letters, numbers, and symbols.</li>
                                <li><i className="fa-solid fa-check me-2" style={{ color: '#8b5e3c' }}></i> Avoid using common words or names.</li>
                                <li><i className="fa-solid fa-check me-2" style={{ color: '#8b5e3c' }}></i> Change your password every few months.</li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </DevLayout>
    )
}
